"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
var react_1 = require("react");
var react_transition_group_1 = require("react-transition-group");
var styled_components_1 = __importStar(require("styled-components"));
var useOnClickOutside_1 = require("../../../hooks/useOnClickOutside");
var __1 = require("../../../");
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: max-content;\n  cursor: pointer;\n"], ["\n  position: relative;\n  width: max-content;\n  cursor: pointer;\n"])));
var DropdownMenuWrapper = styled_components_1.default.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  top: ", "px;\n  position: absolute;\n  left: 0;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  width: max-content;\n  box-shadow: 0px 10px 15px #00000019;\n  min-width: 175px;\n  padding: 6px;\n  border: 1px solid ", ";\n  background: ", ";\n  border-radius: ", "px;\n  &.fade-enter {\n    opacity: 0;\n  }\n\n  &.fade-enter-active {\n    opacity: 1;\n    transition: 0.3s;\n  }\n\n  &.fade-enter-done {\n    opacity: 1;\n  }\n\n  &.fade-exit-active {\n    opacity: 0;\n    transition: 0.3s;\n  }\n"], ["\n  top: ", "px;\n  position: absolute;\n  left: 0;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  width: max-content;\n  box-shadow: 0px 10px 15px #00000019;\n  min-width: 175px;\n  padding: 6px;\n  border: 1px solid ", ";\n  background: ", ";\n  border-radius: ", "px;\n  &.fade-enter {\n    opacity: 0;\n  }\n\n  &.fade-enter-active {\n    opacity: 1;\n    transition: 0.3s;\n  }\n\n  &.fade-enter-done {\n    opacity: 1;\n  }\n\n  &.fade-exit-active {\n    opacity: 0;\n    transition: 0.3s;\n  }\n"])), function (_a) {
    var $top = _a.$top;
    return ($top ? $top : 30);
}, function (_a) {
    var theme = _a.theme;
    return theme.gray3;
}, function (_a) {
    var theme = _a.theme;
    return theme.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.buttonRadius;
});
var MenuItem = styled_components_1.default.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  list-style: none;\n\n  display: flex;\n  width: 100%;\n  color: ", ";\n  transition: 0.3s;\n  border-radius: 5px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n\n  &:hover {\n    background: #f8f8f8;\n  }\n\n  & p {\n    margin: 0px;\n    padding: 12px;\n  }\n"], ["\n  list-style: none;\n\n  display: flex;\n  width: 100%;\n  color: ", ";\n  transition: 0.3s;\n  border-radius: 5px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n\n  &:hover {\n    background: #f8f8f8;\n  }\n\n  & p {\n    margin: 0px;\n    padding: 12px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.textColor;
});
var DropdownMenu = function (_a) {
    var child = _a.child, menuItems = _a.menuItems, isInitiallyOpen = _a.isInitiallyOpen, onClick = _a.onClick, onChange = _a.onChange, top = _a.top;
    var dropdownMenuRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(isInitiallyOpen), isOpen = _b[0], setIsOpen = _b[1];
    var closeMenu = function () { return setIsOpen(false); };
    (0, useOnClickOutside_1.useOnClickOutside)(dropdownMenuRef, function () { return closeMenu(); });
    var onListItemClick = (0, react_1.useCallback)(function (ind) {
        onChange === null || onChange === void 0 ? void 0 : onChange(menuItems[ind]);
        closeMenu();
    }, [menuItems, onChange]);
    return ((0, jsx_runtime_1.jsxs)(Wrapper, __assign({ onClick: onClick }, { children: [(0, react_1.cloneElement)(child, {
                onClick: function () { return setIsOpen(function (prev) { return !prev; }); },
                $isMenuOpen: isOpen,
            }), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, __assign({ in: isOpen, timeout: 300, nodeRef: dropdownMenuRef, classNames: "fade", unmountOnExit: true }, { children: (0, jsx_runtime_1.jsx)(DropdownMenuWrapper, __assign({ ref: dropdownMenuRef, "$top": top }, { children: menuItems.map(function (_a, index) {
                        var id = _a.id, content = _a.content;
                        return ((0, jsx_runtime_1.jsx)(MenuItem, __assign({ onClick: function () { return onListItemClick(index); }, onKeyDown: closeMenu }, { children: (0, jsx_runtime_1.jsx)(__1.Text, __assign({ size: "14", noMargin: true }, { children: content })) }), id));
                    }) })) }))] })));
};
exports.default = (0, styled_components_1.withTheme)((0, styled_components_1.default)(DropdownMenu)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""]))));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
